(function () {
  function ready(fn) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  ready(function () {
    var root = document.querySelector("[data-ushare-intake]");
    if (!root) return;
    var form = root.querySelector("#UshareIntakeForm");
    if (!form) return;

    var steps = Array.prototype.slice.call(root.querySelectorAll("[data-step]"));
    var index = 0;
    var total = steps.length;
    var bar = root.querySelector("[data-progress-bar]");
    var label = root.querySelector("[data-progress-label]");
    var title = root.querySelector("[data-progress-title]");
    var body = root.querySelector("[data-intake-body]");
    var context = root.querySelector("[data-intake-context]");
    var planInput = root.querySelector("#UshareCi-plan");
    var specialistInput = root.querySelector("#UshareCi-specialist");

    function val(sel) {
      var el = root.querySelector(sel);
      return el ? String(el.value || "").trim() : "";
    }

    function chipValues(name) {
      return Array.prototype.map
        .call(root.querySelectorAll('[data-chips="' + name + '"] .ushare-ci-chip.is-on'), function (btn) {
          return btn.getAttribute("data-value") || btn.textContent.trim();
        })
        .filter(Boolean);
    }

    function setChipHidden(name) {
      var input = root.querySelector('[data-chip-input="' + name + '"]');
      if (input) input.value = chipValues(name).join("; ");
    }

    function showStep(next) {
      index = Math.max(0, Math.min(total - 1, next));
      steps.forEach(function (step, i) {
        step.hidden = i !== index;
        if (i === index) step.classList.remove("is-invalid");
      });
      var current = steps[index];
      if (bar) bar.style.width = ((index + 1) / total) * 100 + "%";
      if (label) label.textContent = label.getAttribute("data-template").replace("{current}", String(index + 1)).replace("{total}", String(total));
      if (title && current) title.textContent = current.getAttribute("data-title") || "";
    }

    function requiredFilled(step) {
      var ok = true;
      Array.prototype.forEach.call(step.querySelectorAll("[data-required-input]"), function (el) {
        if (!String(el.value || "").trim()) ok = false;
      });
      Array.prototype.forEach.call(step.querySelectorAll("[data-required-chips]"), function (wrap) {
        if (!wrap.querySelector(".ushare-ci-chip.is-on")) ok = false;
      });
      return ok;
    }

    root.addEventListener("click", function (event) {
      var chip = event.target.closest(".ushare-ci-chip");
      if (chip) {
        var group = chip.closest("[data-chips]");
        if (!group) return;
        if (group.hasAttribute("data-single")) {
          Array.prototype.forEach.call(group.querySelectorAll(".ushare-ci-chip"), function (btn) {
            btn.classList.toggle("is-on", btn === chip);
          });
        } else {
          chip.classList.toggle("is-on");
        }
        setChipHidden(group.getAttribute("data-chips"));
        return;
      }
      if (event.target.closest("[data-next]")) {
        var step = steps[index];
        if (!requiredFilled(step)) {
          step.classList.add("is-invalid");
          return;
        }
        showStep(index + 1);
        return;
      }
      if (event.target.closest("[data-back]")) showStep(index - 1);
    });

    form.addEventListener("submit", function (event) {
      ["plan", "category", "stage", "duration", "trend", "impact", "conditions"].forEach(setChipHidden);
      var missing = steps.findIndex(function (step) {
        return !requiredFilled(step);
      });
      if (missing !== -1) {
        event.preventDefault();
        showStep(missing);
        steps[missing].classList.add("is-invalid");
        return;
      }
      if (body) {
        body.value = [
          "Online consultation / medical case intake",
          "Name: " + val("#UshareCi-name"),
          "Age: " + val("#UshareCi-age"),
          "Gender: " + val("#UshareCi-gender"),
          "Country: " + val("#UshareCi-country"),
          "Email: " + val("#UshareCi-email"),
          "Phone: " + val("#UshareCi-phone"),
          "Consultation option: " + val("#UshareCi-plan"),
          "Preferred specialist: " + val("#UshareCi-specialist"),
          "Main category: " + val('[data-chip-input="category"]'),
          "Diagnosis stage: " + val('[data-chip-input="stage"]'),
          "Duration: " + val('[data-chip-input="duration"]'),
          "Trend: " + val('[data-chip-input="trend"]'),
          "Impact: " + val('[data-chip-input="impact"]'),
          "Symptoms: " + val("#UshareCi-symptoms"),
          "Previous treatments: " + val("#UshareCi-treatments"),
          "Chronic conditions: " + val('[data-chip-input="conditions"]'),
          "History notes: " + val("#UshareCi-history"),
          "Medications / allergies: " + val("#UshareCi-meds"),
          "Records available: " + val("#UshareCi-records"),
          "Goals: " + val("#UshareCi-goals"),
          "Consent: " + (root.querySelector("#UshareCi-consent") && root.querySelector("#UshareCi-consent").checked ? "Yes" : "No")
        ].join("\n");
      }
    });

    function fillFromQuery() {
      var params = new URLSearchParams(window.location.search);
      var plan = (params.get("plan") || "").toLowerCase();
      var specialist = params.get("specialist");
      var planMap = {
        written: "Written Review",
        video: "Video Consultation",
        mdt: "Multidisciplinary Review",
        matching: "Specialist matching"
      };
      if (planMap[plan] && planInput) {
        planInput.value = planMap[plan];
        Array.prototype.forEach.call(root.querySelectorAll('[data-chips="plan"] .ushare-ci-chip'), function (btn) {
          btn.classList.toggle("is-on", (btn.getAttribute("data-value") || "") === planMap[plan]);
        });
      }
      if (specialist && specialistInput) specialistInput.value = specialist;
      if (context && (planMap[plan] || specialist)) {
        var bits = [];
        if (planMap[plan]) bits.push(planMap[plan]);
        if (specialist) bits.push(specialist);
        context.textContent = context.getAttribute("data-template").replace("{detail}", bits.join(" · "));
        context.classList.add("is-on");
      }
    }

    fillFromQuery();
    showStep(0);
  });
})();
